<div *ngIf="organization">
  <div class="card p-0 pt-4 mb-0">
    <div class="flex flex-column mx-4 mb-3">
      <div class="flex flex-column sm:flex-row justify-content-start sm:justify-content-between">
        <p class="inline-block text-4xl flex-order-1 sm:flex-order-0">
          {{'model.organization' | transloco}} {{organization.name}}
          <a class="underline" [routerLink]="'/management/tenants/' + organization.tenant.uuid + '/details'">
            ({{organization.tenant.name}})
          </a>

        </p>
        <div class="flex-order-0 sm:flex-order-1">
          <button
            *ngIf="'ROLE_ADMIN' | userHasRole"
            [label]="'common.edit' | transloco"
            pButton
            pRipple
            class="mr-2 p-button-primary mt-1 mb-3 sm:mb-0 w-full sm:w-auto"
            routerLink="../edit"
            icon="pi pi-pencil"
          ></button>
        </div>
      </div>
      <div>
        <p *ngIf="organization.description"><b>{{'attribute.description' | transloco}}: </b>{{organization.description}}</p>
        <p *ngIf="!organization.description" class="font-italic">{{'empty.description' | transloco}}</p>
      </div>
    </div>
    <div>
      <p-tabMenu
        #tab
        [model]="items"
        [activeItem]="activeItem"
        (click)="activateMenu(tab)"
        class="hidden xl:inline"
      ></p-tabMenu>
      <p-tabMenu
        #tabIcon
        [model]="items"
        [activeItem]="activeItem"
        (click)="activateMenu(tabIcon)"
        class="xl:hidden"
      >
        <ng-template pTemplate="item" let-item let-i="index">
          <i [className]="item.icon"></i>
        </ng-template>
      </p-tabMenu>
    </div>
  </div>
  <div class="with-margin">
    <app-organization-overview [organization]="organization" *ngIf="activeItem.id == 'overview'"></app-organization-overview>
    <app-organization-devices [organization]="organization" *ngIf="activeItem.id == 'devices'"></app-organization-devices>
    <app-organization-assets [organization]="organization" *ngIf="activeItem.id == 'assets'"></app-organization-assets>
    <app-organization-api [organization]="organization" *ngIf="activeItem.id == 'api'"></app-organization-api>
  </div>
</div>
